export const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';

export const getPacienteToken = () => localStorage.getItem('paciente_token');
export const setPacienteToken = (t) => localStorage.setItem('paciente_token', t);
export const removePacienteToken = () => localStorage.removeItem('paciente_token');

export const pacienteAuthHeaders = () => ({
  Authorization: `Bearer ${getPacienteToken()}`,
  Accept: 'application/json',
});

export const pacienteJsonHeaders = () => ({
  ...pacienteAuthHeaders(),
  'Content-Type': 'application/json',
});
